import axios from "axios";
import { useRouter } from "vue-router";
import { getToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
import { ElMessage, ElMessageBox } from "element-plus";
let fileName = "";

const router = useRouter();
const service = axios.create({
  // baseURL: '/axios',
  baseURL: process.env.NODE_ENV === "production" ? "/" : "/", //开发用
  timeout: 6000000,
  header: {
    "Content-Type": "application/json;charset=utf-8",
  },
});

service.interceptors.request.use(
  async (config) => {
    config.headers = {
      ...config.headers,
    };
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    if (getToken() && !isToken) {
      config.headers["common"] = { "zh-token": getToken() }; // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    if (config.type === "formData" && config.data.constructor != FormData) {
      var data = new FormData();
      for (var key in config.data) {
        var val = config.data[key];
        if (val === null || val === undefined) {
          data.append(key, "");
        } else if (val.constructor == Array) {
          for (var i = 0; i < val.length; i++) {
            data.append(
              key,
              typeof val[i] == "object" ? JSON.stringify(val[i]) : val[i]
            );
          }
        } else {
          data.append(key, typeof val == "object" ? JSON.stringify(val) : val);
        }
      }
      config.data = data;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (res) => {
    // 获取响应头信息中的附件名字 start
    let resType = res.headers["content-type"];
    if (resType != undefined && resType.includes("octet-stream")) {
      const disposition = res.headers["content-disposition"];
      fileName = disposition.split("filename=")[1].replace(/\\"/g, "");
      fileName = decodeURI(escape(fileName));
    }
    // 获取响应头信息中的附件名字 end
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.message || errorCode["default"];
    if (code === 401) {
      ElMessageBox.confirm(
        "登录状态已过期，您可以继续留在该页面，或者重新登录",
        "系统提示",
        {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {})
        .catch(() => {});
    } else if (code == 500) {
      ElMessage({
        dangerouslyUseHTMLString: true,
        message: res.msg || res.data.msg,
        type: "error",
      });
      return Promise.reject(new Error(msg));
    } else if (code == 409) {
      ElMessage({
        message: res.data.message,
        type: "warning",
        duration: 4000,
      });
      return Promise.reject("error");
    } else if (code == 400 || code == 403) {
      ElMessage({
        message: res.data.message,
        type: "warning",
      });
      return Promise.reject("error");
    } else if (code == 2000 || code == 200) {
      console.log("接口调用成功");
      return res.data;
    } else {
      ElMessage({
        message: res.data.message || res.msg,
        type: "error",
      });
      return Promise.reject("error");
    }
  },
  (error) => {
    if (error.response) {
      const data = error.response.data;
      const errCode = data.code;
    }
    return Promise.reject(error);
  }
);

export default service;
